import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import i18n from 'simple-react-i18n'
import { getFileExtension, getFileInfo } from 'utils/FileUtils'
import useSandreList from 'utils/customHook/useSandreList'
import { isNil } from 'lodash'
import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import Input from 'components/forms/Input'
import Select from 'components/forms/Select'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import Checkbox from 'components/forms/Checkbox'
import DtoFile from 'components/file/dto/DtoFile'
import { ShapeSamplePoint } from 'station/shapes/StationShapes'
import { DOCUMENT, PICTURE, PICTURES_EXTENSIONS } from 'components/file/constant/FileConstants'
import ReferencialFileAction from './actions/ReferencialFileAction'

const UpdateFileDialog = ({
    isOpen = false,
    onClose = () => {},

    fileName,
    files = [],
}) => {
    const [name, setName] = useState('')
    const [fileType, setFileType] = useState(0)
    const [date, setDate] = useState('')
    const [active, setActive] = useState('0')

    const dispatch = useDispatch()

    const formattedFiles = useMemo(() => (files || []).map(doc => {
        const extension = `.${getFileExtension(doc.name)?.toLowerCase()}`

        return {
            ...doc,
            code: doc.code,
            url: doc.path,
            name: doc.name,
            date: doc.dateMaj,
            active: doc.actif ? '1' : '0',
            Nature: doc.nature,
            fileType: PICTURES_EXTENSIONS.includes(extension)? PICTURE: DOCUMENT,
        }
    }), [files])

    const file = useMemo(() => formattedFiles.find(f => f.name === fileName), [formattedFiles, fileName])


    const {
        sandreConstant,
        fileTypeName,
    } = getFileInfo(file)


    const fileTypes = useSandreList(sandreConstant)

    useEffect(() => {
        if (isNil(file)) return

        setName(file.name)
        setFileType(file.nature)
        setDate(file.date)
        setActive(file.active === '1')
    }, [file])


    const saveFile = () => {
        const formattedFile = {
            id: file.id,
            code: file.code,
            name,
            path: file.path,
            content: '',
            loginmaj: file.loginmaj,
            dateMaj: date || file.dateMaj,
            nature: fileType,
            actif: active,
        }


        dispatch(ReferencialFileAction.updateFile(formattedFile))

        onClose()
    }

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth='lg'
        >
            <DefaultDialogTitle
                title={`${i18n.update}: ${file?.name}`}
                onClose={onClose}
            />
            <DialogContent>
                <Card>
                    <CardContent sx={{ overflow: 'hidden' }}>
                        <Grid container spacing={1} alignItems='center'>
                            <Grid size={12}>
                                <Input
                                    title={i18n.name}
                                    value={name}
                                    onChange={setName}
                                />
                            </Grid>
                            <Grid size={12}>
                                <Select
                                    label={fileTypeName}
                                    options={fileTypes}
                                    value={fileType}
                                    onChange={setFileType}
                                    noNullValue
                                    noSort
                                    keyLabel='name'
                                />
                            </Grid>
                            <Grid size={3}>
                                <SimpleDatePicker
                                    label={i18n.date}
                                    value={date}
                                    onChange={setDate}
                                />
                            </Grid>
                            <Grid size={3}>
                                <Checkbox
                                    onChange={setActive}
                                    checked={active}
                                    label={i18n.active}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={saveFile}
                    variant='contained'
                    color='primary'
                    disabled={isNil(name) || isNil(fileType)}
                >
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

UpdateFileDialog.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    fileName: PropTypes.string,
    files: PropTypes.arrayOf(PropTypes.instanceOf(DtoFile)),
    stationType: PropTypes.string,
    linkSamplePoints: PropTypes.arrayOf(ShapeSamplePoint),
    updateData: PropTypes.func,
}

export default UpdateFileDialog